const LocalStorage = {
  storeData: (KEY, data) => {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(data));
    } catch (e) {
      // saving error
      console.log("Storage error: ", e);
    }
  },
  getData: (KEY) => {
    try {
      const value = window.localStorage.getItem(KEY);
      if (value !== null) {
        return JSON.parse(value);
      } else {
        return null;
      }
    } catch (e) {
      console.log("Storage retrieve error: ", e);
    }
    return null;
  },
  delete: (KEY) => {
    try {
      window.localStorage.removeItem(KEY);
    } catch (e) {
      console.log("Storage delete error: ", e);
    }
  },
};

export default LocalStorage;
